/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEventStateRequestDto
 */
export interface UpdateEventStateRequestDto {
    /**
     * Unique code for the event state (uppercase letters, digits, and underscores only, starting with a letter)
     * @type {string}
     * @memberof UpdateEventStateRequestDto
     */
    code?: string;
    /**
     * Name of the event state
     * @type {string}
     * @memberof UpdateEventStateRequestDto
     */
    name?: string;
}

/**
 * Check if a given object implements the UpdateEventStateRequestDto interface.
 */
export function instanceOfUpdateEventStateRequestDto(value: object): value is UpdateEventStateRequestDto {
    return true;
}

export function UpdateEventStateRequestDtoFromJSON(json: any): UpdateEventStateRequestDto {
    return UpdateEventStateRequestDtoFromJSONTyped(json, false);
}

export function UpdateEventStateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEventStateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function UpdateEventStateRequestDtoToJSON(json: any): UpdateEventStateRequestDto {
    return UpdateEventStateRequestDtoToJSONTyped(json, false);
}

export function UpdateEventStateRequestDtoToJSONTyped(value?: UpdateEventStateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

